import axios from "axios";
import { fetchAuthSession } from "aws-amplify/auth";
import { ApiError } from "../../../../shared/utils/errors/ApiError";

export async function embeddedWhatsAppSignup(payload) {
  try {
    const session = await fetchAuthSession();

    const idToken = session.tokens?.idToken?.toString();
    const accessToken = session.tokens?.accessToken?.toString();

    if (!idToken || !accessToken) {
      throw new ApiError({
        error: "auth_error",
        message: "Tokens Cognito não encontrados",
      });
    }

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_AWS_URL}/channels/whatsappapi/embedded-signup`,
      {
        ...payload,
        cognitoTokens: {
          idToken,
          accessToken,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
          Client_ID: idToken,
        },
      }
    );

    return response.data;

  } catch (error) {
    if (axios.isAxiosError(error)) {
      const apiError = error.response?.data;
      if (apiError?.error && apiError?.message) {
        throw new ApiError(apiError);
      }
    }

    if (error instanceof ApiError) {
      throw error;
    }

    throw new ApiError({
      error: "unknown_error",
      message: "Erro ao integrar WhatsApp",
    });
  }
}